<div
  *ngIf="show"
  class="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-slide-down"
>
  <div
    class="flex flex-col items-center gap-3 px-6 py-4 bg-white min-w-[320px] rounded-2xl shadow-2xl"
  >
    <div class="flex items-center gap-3 w-full">
      <div
        class="flex-shrink-0 w-10 h-10 bg-white rounded-full flex items-center justify-center"
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="6"
            y="10"
            width="24"
            height="24"
            rx="8"
            fill="#20202A"
            stroke="#20202A"
            stroke-width="2"
          />
          <rect
            x="10"
            y="6"
            width="24"
            height="24"
            rx="8"
            fill="white"
            stroke="#20202A"
            stroke-width="2"
          />
          <path
            d="M16 17.4444L20 21L28 13"
            stroke="#E62721"
            stroke-width="3"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="flex-1">
        <h3
          class="text-[14px] font-poppins font-semibold text-neutral-gray-900 leading-tight"
        >
          {{ title }}
        </h3>
        <p class="text-[12px] font-poppins text-neutral-gray-700 leading-tight">
          {{ subtitle }}
        </p>
      </div>
      <button (click)="onClose()" class="flex-shrink-0">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="#7E808F"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
    <div
      *ngIf="showProgress"
      class="progress-container w-[280px] md:w-[360px] h-[6px] bg-neutral-gray-200 rounded-full overflow-hidden"
    >
      <div
        class="progress-bar h-full bg-neutral-gray-900 rounded-full"
        [style.width.%]="progressValue"
      ></div>
    </div>
  </div>
</div>